import styles from './BenefitsSection.module.scss';
import LineBreak from '../LineBreak';
import melhoriaSono from '../../images/melhoria-sono.svg';
import melhoriaNotas from '../../images/melhoria-notas.svg';
import diminuicaoTempo from '../../images/diminuicao-tempo.svg';
import fortalecimentoLacos from '../../images/fortalecimento-lacos.svg';

function BenefitsSection() {
  return (
    <div className={styles.benefits}>
      <div className={styles.container}>
        <h2>
          NOSSOS
          <LineBreak />
          BENEFÍCIOS
        </h2>
        <div className={styles.benefitSleep}>
          <img src={melhoriaSono} alt="Melhoria do Sono" />
        </div>
        <div className={styles.benefitScreenTime}>
          <img src={diminuicaoTempo} alt="Diminuição do Tempo de Tela" />
        </div>

        <div className={styles.benefitGrades}>
          <img src={melhoriaNotas} alt="Melhoria das Notas" />
        </div>
        <div className={styles.benefitFamily}>
          <img
            src={fortalecimentoLacos}
            alt="Fortalecimento dos Laços Familiares"
          />
        </div>
      </div>
    </div>
  );
}

export default BenefitsSection;
